export default {
  lang: 'en',
  view: '360',
  order: {
    quantity: 1
  }
}
